<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>


        <div class="col-lg-5">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="expenseDate" inputId="expenseDate">
            </p-calendar>
            <label>Expense Date</label>
            @for (validation of validationMessages.expenseDate; track validation) {
              <span>
                @if (form1.get('expenseDate').hasError(validation.type) && (form1.get('expenseDate').dirty || form1.get('expenseDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        @if (!ownerStmtExpId) {
          <div class="col-lg-5"></div>
        }
        @if (ownerStmtExpId) {
          <div class="col-lg-3 d-flex justify-content-end">
            <label>Show To Statement : </label>
          </div>
        }
        @if (ownerStmtExpId) {
          <div class="col-lg-2">
            <span class="p-float-label required-field w-100 mb-3">
              <p-inputSwitch formControlName="showToStmt">
              </p-inputSwitch>
              @for (validation of validationMessages.showToStmt; track validation) {
                <span>
                  @if (form1.get('showToStmt').hasError(validation.type) && (form1.get('showToStmt').dirty || form1.get('showToStmt').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        }

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="description" id="description" type="text" pInputText>
            <label for="description">Description</label>
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="ownerNotes" id="ownerNotes" [rows]="2" pInputTextarea></textarea>
            <label for="ownerNotes">Owner Notes</label>
            @for (validation of validationMessages.ownerNotes; track validation) {
              <span>
                @if (form1.get('ownerNotes').hasError(validation.type) && (form1.get('ownerNotes').dirty || form1.get('ownerNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
            <label for="opsNotes">Ops Notes</label>
            @for (validation of validationMessages.opsNotes; track validation) {
              <span>
                @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!--Many to One Relation field-->


        <!--Many to One Relation field-->


        <!--Many to One Relation field-->

      </div>

    </div>
    <hr>

      @if (ownerStmtExpId) {
        <div>
          <div class="col-lg-12">
            <h6>Owner Stmt Exp Detail</h6>
          </div>
        </div>
      }

      <hr>

        <div class="row m-0">
          <div class="col-lg-12">
            <div class="btn-group">
              <div class="button-group">
                @if (ownerStmtExpId) {
                  <button pButton class="btn-delete p-button-outlined p-button-danger"
                  (click)="onFormDelete()">Delete Owner Stmt Exp</button>
                }
              </div>

              <div class="button-group">
                <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
                @if (!ownerStmtExpId) {
                  <button pButton class="btn-addt p-button" (click)="formAdd()">Add Owner Stmt Exp</button>
                }

                @if (ownerStmtExpId) {
                  <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Owner Stmt Exp</button>
                }
              </div>
            </div>
          </div>
        </div>

      </div>
